import { render, staticRenderFns } from "./VisitorApprovalList.vue?vue&type=template&id=7cdbbffd&scoped=true&"
import script from "./VisitorApprovalList.vue?vue&type=script&lang=js&"
export * from "./VisitorApprovalList.vue?vue&type=script&lang=js&"
import style0 from "./VisitorApprovalList.vue?vue&type=style&index=0&id=7cdbbffd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdbbffd",
  null
  
)

export default component.exports